/**
 * Preloads all variant images for a product
 */
class ProductImagePreloader {
  constructor() {
    this.selectors = {
      productMedia: '[data-product-media-type-image]',
      productJSON: '[data-product-json]'
    };

    this.init();
  }

  init() {
    // Find all product sections
    const productSections = document.querySelectorAll('[data-section-type="product"]');
    productSections.forEach(section => this.preloadProductImages(section));
  }

  preloadProductImages(section) {
    // Get product JSON
    const productJSON = section.querySelector(this.selectors.productJSON);
    if (!productJSON) return;

    try {
      const product = JSON.parse(productJSON.innerHTML);
      if (!product.media) return;

      // Create preload links for all product media
      product.media.forEach(media => {
        if (media.media_type === 'image') {
          this.preloadImage(media.src);
        }
      });

      // Also preload variant specific images
      if (product.variants) {
        product.variants.forEach(variant => {
          if (variant.featured_media && variant.featured_media.src) {
            this.preloadImage(variant.featured_media.src);
          }
        });
      }
    } catch (e) {
      console.warn('Error preloading product images:', e);
    }
  }

  preloadImage(src) {
    const link = document.createElement('link');
    link.rel = 'preload';
    link.as = 'image';
    link.href = src;
    document.head.appendChild(link);
  }
}

// Initialize the preloader when the DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  new ProductImagePreloader();
});
